<template>
  <div class="order-details-sidebar">
    <!-- Container 2: Consultant, Date created, Status, Dongels -->
    <div class="detail-container">
      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.consultant").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.agent.full_name || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.date_created").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.created_at ? order.created_at.substring(0, 10) : '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.status").toUpperCase() }}:</span>
        <span class="status-badge" :class="'status-' + (order.status || 'unknown').toLowerCase().replace('_', '-')">
          {{ order.status || '-' }}
        </span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.units").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.devices ? order.devices.length : 0 }}</span>
      </div>
    </div>

    <!-- Container 3: Start datum, Tijd, Betaaltermijn, Betalingswijze -->
    <div class="detail-container">
      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.start_date").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.contract_start_on || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.contract").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.contract_duration }} Maanden</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.payment_term").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.payment_term_name || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.payment_type").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.payment_type || '-' }}</span>
      </div>
    </div>

    <!-- Container 4: Zakelijk, Retroactive Invoicing -->
    <div class="detail-container">
      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.send_invoices").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.send_invoices ? 'Yes' : 'No' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.retroactive_invoicing").toUpperCase() }}:</span>
        <span class="detail-value">{{ order.retroactive_invoicing ? 'Yes' : 'No' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: () => {
        return {
          agent: {
            full_name: "",
          },
          customer: {
            id: 0,
            company_name: "",
            company_country: "",
            contact_first_name: "",
            contact_last_name: "",
            contact_email: ""
          },
          created_at: "",
          status: "",
          contract_start_on: "",
          contract_duration: 0,
          payment_term_name: "",
          payment_type: "",
          send_invoices: false,
          retroactive_invoicing: false,
          devices: [],
          inquiry: {
            company: {
              name: ""
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.order-details-sidebar {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
}

.detail-container:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-label {
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
  line-height: 1.4;
  word-break: break-word;
}

.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  width: fit-content;
}

.status-new {
  background-color: #e3f2fd;
  color: #1976d2;
}

.status-pending {
  background-color: #fff3e0;
  color: #f57c00;
}

.status-confirmed {
  background-color: #e8f5e9;
  color: #388e3c;
}

.status-cancelled,
.status-canceled {
  background-color: #ffebee;
  color: #d32f2f;
}

.status-completed {
  background-color: #e8f5e9;
  color: #388e3c;
}

.status-shipped {
  background-color: #e3f2fd;
  color: #1976d2;
}

.status-active {
  background-color: #e8f5e9;
  color: #388e3c;
}

.status-terminated {
  background-color: #ffebee;
  color: #d32f2f;
}

.status-unknown {
  background-color: #f5f5f5;
  color: #757575;
}

@media (max-width: 768px) {
  .order-details-sidebar {
    gap: 20px;
  }

  .detail-container {
    gap: 12px;
    padding-bottom: 20px;
  }

  .detail-item {
    gap: 6px;
  }
}
</style>
